import React from 'react';
import { AlFormField } from './AlFormField/AlFormField';
import Select from '@mui/material/Select';

const AlSelectField = (props) => {
    return <AlFormField {...props} field={Select} variant="outlined" />;
};

export { AlSelectField };
